import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { sbaAxios } from '../../../utils/sbaAxios';
import { DateRangePicker } from "rsuite";
import moment from "moment";
import {
  getPrivateExposureAssetList,
  getMinMaxReturnDates,
  getPrivateExposureCategoryTypes,
  getPrivateExposureCategoryTypeDates,
  getPrivateExposureAssetData
} from "../../../../config/apiConfig";
import { TileLayout } from "@progress/kendo-react-layout";
import {
  Chart,
  ChartLegend,
  ChartTitle,
  ChartCategoryAxis,
  ChartCategoryAxisItem,
  ChartValueAxis,
  ChartValueAxisItem,
  ChartSeries,
  ChartSeriesItem,
} from "@progress/kendo-react-charts";
import { SBAComboBox } from "../../../UiComponents/SBADropDown";
import { getAssestListddlAction } from "../../../actions/assetsddlAction";
import { UrlPath } from "../../../../config/routeConfig";
import { ExposureCategory } from "../../../../config/exposureConfig";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router";
import { getAsset } from "../../../actions/assetAction";
import { getAssetSettings } from "../../../actions/assetSettingsAction";
import { LoadingScreen } from "../../../UiComponents/LoadingComponent";
import { SBDateRangePicker } from "../../../UiComponents/SBDateRangePicker";
import { SBNotify } from "../../../utils/sbNotify";

export const PrivateCharts = () => {
  const dispatch = useDispatch();
  const params = useParams();
  const history = useNavigate();
  const [render, setRender] = useState(true);
  const [assetListData, setAssetListData] = useState([]);
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [selectedAsset, setSelectedAsset] = useState([]);
  const [exposureCategoryTypeData, setExposureCategoryTypeData] = useState([]);
  const [widgetView, setWidgetView] = useState(false);
  const [checkedCategories, setCheckedCategories] = useState([]);
  const [Loading, setLoading] = useState(false);
  const [categoryData, setCategoryData] = useState([]);

  const AssestDDChanged = (e) => {
    setRender(!render);
    e.value
      ? history(`${UrlPath.PrivateExposure}${e.value.AssetId}`)
      : history(`${UrlPath.PrivateExposure}${params.Asset}`);
    setSelectedAsset(e.value);
    setWidgetView(false);
    getMinMaxValues();
  };

  const handleDateChange = (e) => {
    if(e)
    {
        const newStartDate = e.value.start !== null ? e.value.start : startDate;
        const newEndDate = e.value.end !== null ? e.value.end : endDate;
        setStartDate(newStartDate)
        setEndDate(newEndDate)
     
    }
  };

  useEffect(() => {
    const assetListData = async () => {
      try {
        const response = await sbaAxios({
          url: `${getPrivateExposureAssetList}`,
          method: "get",
        });
        const data = response;
        setAssetListData(data);
      } catch (error) {
        console.error("Error fetching assetListData from API:", error);
      }
    };

    assetListData();
  }, []);
  const getMinMaxValues = async () => {
    if (selectedAsset.AssetId) {
      try {
        const response = await sbaAxios({
          url: `${getMinMaxReturnDates}${selectedAsset.AssetId},${1},${3}`,
          method: "get",
        });
        const MinMaxDateValue = {
          MinDate: response.StartDate,
          MaxDate: response.EndDate,
        };
        if (
          MinMaxDateValue.MinDate !== null &&
          MinMaxDateValue.MaxDate !== null
        ) {
          setStartDate(MinMaxDateValue.MinDate);
          setEndDate(MinMaxDateValue.MaxDate);
        }
      } catch (error) {
        console.error("Error fetching MinMaxValues from API:", error);
      }
    }
  };
  useEffect(() => {
    getMinMaxValues();
    const getAvailableChartLists = async () => {
      if (selectedAsset.AssetId) {
        try {
          const response = await sbaAxios({
            url: `${getPrivateExposureCategoryTypes}assetId=${selectedAsset.AssetId}`,
            method: "get",
          });
          const data = response;
          setExposureCategoryTypeData(val=>data);
          setCheckedCategories(val=>
            data.map((item) => ({
              categoryType: item.ExposureCategoryType,
              categoryId: item.ExposureCategoryTypeId,
              isChecked: true,
            }))
          );
        } catch (error) {
          console.error("Error fetching AvailableChartLists from API:", error);
          setExposureCategoryTypeData(val=>[]);
          setCheckedCategories(val=>[]);
        }
      }
    };

    getMinMaxValues();
    getAvailableChartLists();
  }, [selectedAsset]);

  const handleCategoryTypeChange = (
    event,
    ExposureCategoryType,
    ExposureCategoryTypeId
  ) => {
    const isChecked = event.target.checked;
    if (isChecked) {
      setCheckedCategories((prevChecked) => [
        ...prevChecked,
        {
          categoryType: ExposureCategoryType,
          categoryId: ExposureCategoryTypeId,
        },
      ]);
    } else {
      setCheckedCategories((prevChecked) =>
        prevChecked.filter((item) => item.categoryType !== ExposureCategoryType)
      );
    }
  };

  //Enter to generate chart
  const enterButtonClick = async () => {
    const formattedStartDate = moment(startDate).format("MM-DD-YYYY");
    const formattedEndDate = moment(endDate).format("MM-DD-YYYY");

    const newData = [];

    for (const checkedCategory of checkedCategories) {
      const { categoryId } = checkedCategory;

      if (
        formattedStartDate !== formattedEndDate &&
        Object.values(ExposureCategory).includes(categoryId)
      ) {
        const apiUrl = `${getPrivateExposureAssetData}${formattedStartDate}/${formattedEndDate}/${
          selectedAsset.AssetId
        }/${categoryId}/${true}`;

        try {
          const response = await sbaAxios({
            url: apiUrl,
            method: "get",
          });
          const data = response;
          newData.push({ categoryId, data });
        } catch (error) {
          newData.push({ categoryId, data: [] });
          SBNotify({
            type: "error",
            Msg: "Some Exception occured Please Contact Admin",
          });
          console.error(
            `Error fetching Private Chart for category ${categoryId} from API:`,
            error
          );
        }
      }
      }

    // Update the state with the new data
    setCategoryData(newData);
    setLoading(false);
    setWidgetView(true);
  };

  //Clear All
  const clearButtonClick = (e) => {
    setSelectedAsset([""]);
    setStartDate(new Date());
    setEndDate(new Date());
    setExposureCategoryTypeData([]);
    setWidgetView(false);
  };

  const Gstate =
    useSelector((state) => {
      return state;
    }) || {};

  useEffect(() => {
    document.title = "Exposure";
    dispatch(getAssestListddlAction());
    dispatch(getAsset(params.Asset));
    dispatch(getAssetSettings(params.Asset));
  }, [render]);

  useEffect(() => {
    if (currentAsset && AssetListDDL) {
      setSelectedAsset(currentAsset);
    }
  }, [Gstate]);

  const AssetListDDL = Gstate.assetDDL.assetList || [];

  const currentAsset = Gstate.asset.asset || {};

  const [data, setData] = React.useState([
    {
      col: 1,
      colSpan: 2,
      rowSpan: 2,
    },
    {
      col: 3,
      colSpan: 2,
      rowSpan: 2,
    },
    {
      col: 1,
      colSpan: 2,
      rowSpan: 2,
    },
    {
      col: 3,
      colSpan: 2,
      rowSpan: 2,
    },
    {
      col: 1,
      colSpan: 2,
      rowSpan: 2,
    },
    {
      col: 3,
      colSpan: 2,
      rowSpan: 2,
    },
    {
      col: 1,
      colSpan: 2,
      rowSpan: 2,
    },
    {
      col: 3,
      colSpan: 2,
      rowSpan: 2,
    },
    {
      col: 1,
      colSpan: 2,
      rowSpan: 2,
    },
    {
      col: 3,
      colSpan: 2,
      rowSpan: 2,
    },
    {
      col: 1,
      colSpan: 2,
      rowSpan: 2,
    },
    {
      col: 3,
      colSpan: 2,
      rowSpan: 2,
    },
    {
      col: 1,
      colSpan: 2,
      rowSpan: 2,
    },
    {
      col: 3,
      colSpan: 2,
      rowSpan: 2,
    },
    {
      col: 1,
      colSpan: 2,
      rowSpan: 2,
    },
    {
      col: 3,
      colSpan: 2,
      rowSpan: 2,
    },
    {
      col: 1,
      colSpan: 2,
      rowSpan: 2,
    },
    {
      col: 3,
      colSpan: 2,
      rowSpan: 2,
    },
    {
      col: 1,
      colSpan: 2,
      rowSpan: 2,
    },
    {
      col: 3,
      colSpan: 2,
      rowSpan: 2,
    },
    {
      col: 1,
      colSpan: 2,
      rowSpan: 2,
    },
    {
      col: 3,
      colSpan: 2,
      rowSpan: 2,
    },
  ]);

  //common for charts
  const areaChartType = "area";
  const columnChartType = "column";
  const lineChartType = "line";

  const chartData = {
    Sector: {
      categories: [],
      minDate: [],
      maxDate: [],
      stepCount: [],
      chartData: [],
    },
    Geography: {
      categories: [],
      minDate: [],
      maxDate: [],
      stepCount: [],
      chartData: [],
    },
    Strategy: {
      categories: [],
      minDate: [],
      maxDate: [],
      stepCount: [],
      chartData: [],
    },
    MarketCap: {
      categories: [],
      minDate: [],
      maxDate: [],
      stepCount: [],
      chartData: [],
    },
    Liquidity: {
      categories: [],
      minDate: [],
      maxDate: [],
      stepCount: [],
      chartData: [],
    },
    Concentration: {
      categories: [],
      minDate: [],
      maxDate: [],
      stepCount: [],
      chartData: [],
    },
    AssetLevel: {
      categories: [],
      minDate: [],
      maxDate: [],
      stepCount: [],
      chartData: [],
    },
    TotalNumberPositions: {
      categories: [],
      minDate: [],
      maxDate: [],
      stepCount: [],
      chartData: [],
    },
    Leverage: {
      categories: [],
      minDate: [],
      maxDate: [],
      stepCount: [],
      chartData: [],
    },
    Sector_Gross: {
      categories: [],
      minDate: [],
      maxDate: [],
      stepCount: [],
      chartData: [],
    },
    ProductAssetClass: {
      categories: [],
      minDate: [],
      maxDate: [],
      stepCount: [],
      chartData: [],
    },
    RatesCurrency: {
      categories: [],
      minDate: [],
      maxDate: [],
      stepCount: [],
      chartData: [],
    },
    OptionPremium: {
      categories: [],
      minDate: [],
      maxDate: [],
      stepCount: [],
      chartData: [],
    },
    OptionDAE: {
      categories: [],
      minDate: [],
      maxDate: [],
      stepCount: [],
      chartData: [],
    },
    AUM: {
      categories: [],
      minDate: [],
      maxDate: [],
      stepCount: [],
      chartData: [],
    },
    Valuations: {
      categories: [],
      minDate: [],
      maxDate: [],
      stepCount: [],
      chartData: [],
    },
    Privates: {
      categories: [],
      minDate: [],
      maxDate: [],
      stepCount: [],
      chartData: [],
    },
    Credit: {
      categories: [],
      minDate: [],
      maxDate: [],
      stepCount: [],
      chartData: [],
    },
    Geography_Gross: {
      categories: [],
      minDate: [],
      maxDate: [],
      stepCount: [],
      chartData: [],
    },
    Market_Cap_Gross: {
      categories: [],
      minDate: [],
      maxDate: [],
      stepCount: [],
      chartData: [],
    },
    Asset_Concentration_Gross: {
      categories: [],
      minDate: [],
      maxDate: [],
      stepCount: [],
      chartData: [],
    },
    Asset_Level_Of_Gross: {
      categories: [],
      minDate: [],
      maxDate: [],
      stepCount: [],
      chartData: [],
    },
  };

  for (const category of categoryData) {
    const { categoryId, data } = category;
    if(data.length==0)
    continue;


    const categoryChart = data?.[0] || null;
    const chartType =
      categoryId === ExposureCategory.Sector
        ? "Sector"
        : categoryId === ExposureCategory.Geography
        ? "Geography"
        : categoryId === ExposureCategory.Strategy
        ? "Strategy"
        : categoryId === ExposureCategory.MarketCap
        ? "MarketCap"
        : categoryId === ExposureCategory.Liquidity
        ? "Liquidity"
        : categoryId === ExposureCategory.Concentration
        ? "Concentration"
        : categoryId === ExposureCategory.AssetLevel
        ? "AssetLevel"
        : categoryId === ExposureCategory.TotalNumberPositions
        ? "TotalNumberPositions"
        : categoryId === ExposureCategory.Leverage
        ? "Leverage"
        : categoryId === ExposureCategory.Sector_Gross
        ? "Sector_Gross"
        : categoryId === ExposureCategory.ProductAssetClass
        ? "ProductAssetClass"
        : categoryId === ExposureCategory.RatesCurrency
        ? "RatesCurrency"
        : categoryId === ExposureCategory.OptionPremium
        ? "OptionPremium"
        : categoryId === ExposureCategory.OptionDAE
        ? "OptionDAE"
        : categoryId === ExposureCategory.AUM
        ? "AUM"
        : categoryId === ExposureCategory.Valuations
        ? "Valuations"
        : categoryId === ExposureCategory.Privates
        ? "Privates"
        : categoryId === ExposureCategory.Credit
        ? "Credit"
        : categoryId === ExposureCategory.Geography_Gross
        ? "Geography_Gross"
        : categoryId === ExposureCategory.Market_Cap_Gross
        ? "Market_Cap_Gross"
        : categoryId === ExposureCategory.Asset_Concentration_Gross
        ? "Asset_Concentration_Gross"
        : categoryId === ExposureCategory.Asset_Level_Of_Gross
        ? "Asset_Level_Of_Gross"
        : null;

    if (chartType) {
      const chartDataEntry = chartData[chartType];

      chartDataEntry.categories.push(categoryChart.ExposureDateString || []);
      chartDataEntry.minDate.push(categoryChart.MinDateForDataAvailable || []);
      chartDataEntry.maxDate.push(categoryChart.MaxDateForDataAvailable || []);
      const stepCount =
        categoryChart.ExposureDateString?.length > 160
          ? 6
          : categoryChart.ExposureDateString?.length > 120
          ? 3
          : 0;
      chartDataEntry.stepCount.push(stepCount);

      if (Array.isArray(data)) {
        for (const item of data) {
          const chartItem = {
            name: item.ExposureCategory || "",
            type:
              item.ExposureCategory.indexOf("Net") > 0
                ? lineChartType
                : areaChartType,
            data: item.NetValue || [],
            color: item.CategoryColor || "",
            visibleInLegend: item.ExposureCategory === "Hide" ? false : true,
          };
          chartDataEntry.chartData.push(chartItem);
        }
      }
    }
  }

  const tiles = [];
  checkedCategories.forEach((checkedCategory) => {
    const { categoryId } = checkedCategory;

    if (categoryId === ExposureCategory.Sector) {
      const sectorTile = {
        header: (
          <div className="header-container">
            <b>
              {selectedAsset.AssetName} - Sector ({chartData.Sector.minDate} to {chartData.Sector.maxDate})
            </b>
          </div>
        ),
        body: (
          <>
            <Chart>
              <ChartCategoryAxis>
                {chartData.Sector.categories.map((category, index) => (
                  <ChartCategoryAxisItem
                    key={category}
                    categories={category}
                    labels={{
                      step: chartData.Sector.stepCount[index],
                      rotation: 90,
                      position: "start",
                    }}
                  />
                ))}
              </ChartCategoryAxis>
              <ChartValueAxis>
                <ChartValueAxisItem
                  name="primary"
                  color="#7D7D7D"
                  labels={{ format: "{0}%", position: "right" }}
                  majorGridLines={{ visible: false }}
                />
              </ChartValueAxis>
              <ChartSeries>
                {chartData.Sector.chartData.map((series) => (
                  <ChartSeriesItem
                    key={series.name}
                    type={series.type}
                    data={series.data}
                    name={series.name}
                    color={series.color}
                    tooltip={{ visible: true, format: "{0:n1}%" }}
                    opacity={1}
                    visibleInLegend={series.visibleInLegend}
                  />
                ))}
              </ChartSeries>

              <ChartLegend position="bottom" visible={true} />
            </Chart>
          </>
        ),
      };
      tiles.push(sectorTile);
    } else if (categoryId === ExposureCategory.Geography) {
      const GeographyTile = {
        header: (
          <div className="header-container">
            <b>
              {selectedAsset.AssetName} - Geography (
              {chartData.Geography.minDate} to {chartData.Geography.maxDate})
            </b>
          </div>
        ),
        body: (
          <>
            <Chart>
            <ChartCategoryAxis>
                {chartData.Geography.categories.map((category, index) => (
                  <ChartCategoryAxisItem
                    key={category}
                    categories={category}
                    labels={{
                      step: chartData.Geography.stepCount[index],
                      rotation: 90,
                      position: "start",
                    }}
                  />
                ))}
              </ChartCategoryAxis>
              <ChartValueAxis>
                <ChartValueAxisItem
                  name="primary"
                  color="#7D7D7D"
                  labels={{ format: "{0}%", position: "right" }}
                  majorGridLines={{ visible: false }}
                />
              </ChartValueAxis>
              <ChartSeries>
                {chartData.Geography.chartData.map((series) => (
                  <ChartSeriesItem
                    key={series.name}
                    type={series.type}
                    data={series.data}
                    name={series.name}
                    color={series.color}
                    tooltip={{ visible: true, format: "{0:n1}%" }}
                    opacity={1}
                    visibleInLegend={series.visibleInLegend}
                  />
                ))}
              </ChartSeries>
              <ChartLegend position="bottom" visible={true} />
            </Chart>
          </>
        ),
      };
      tiles.push(GeographyTile);
    } else if (categoryId === ExposureCategory.Strategy) {
      const StrategyTile = {
        header: (
          <div className="header-container">
            <b>
              {selectedAsset.AssetName} - Strategy ({chartData.Strategy.minDate}{" "}
              to {chartData.Strategy.minDate})
            </b>
          </div>
        ),
        body: (
          <>
            <Chart>
            <ChartCategoryAxis>
                {chartData.Strategy.categories.map((category, index) => (
                  <ChartCategoryAxisItem
                    key={category}
                    categories={category}
                    labels={{
                      step: chartData.Strategy.stepCount[index],
                      rotation: 90,
                      position: "start",
                    }}
                  />
                ))}
              </ChartCategoryAxis>
              <ChartValueAxis>
                <ChartValueAxisItem
                  name="primary"
                  color="#7D7D7D"
                  labels={{ format: "{0}%", position: "right" }}
                  majorGridLines={{ visible: false }}
                />
              </ChartValueAxis>
              <ChartSeries>
                {chartData.Strategy.chartData.map((series) => (
                  <ChartSeriesItem
                    key={series.name}
                    type={series.type}
                    data={series.data}
                    name={series.name}
                    color={series.color}
                    tooltip={{ visible: true, format: "{0:n1}%" }}
                    opacity={1}
                    visibleInLegend={series.visibleInLegend}
                  />
                ))}
              </ChartSeries>
              <ChartLegend position="bottom" visible={true} />
            </Chart>
          </>
        ),
      };
      tiles.push(StrategyTile);
    } else if (categoryId === ExposureCategory.MarketCap) {
      const MarketCapTile = {
        header: (
          <>
            <div className="d-flex justify-content-between">
              <b>
                {selectedAsset.AssetName} - Market Cap (
                {chartData.MarketCap.minDate} to {chartData.MarketCap.maxDate})
              </b>
            </div>
          </>
        ),
        body: (
          <>
            <Chart>
            <ChartCategoryAxis>
                {chartData.MarketCap.categories.map((category, index) => (
                  <ChartCategoryAxisItem
                    key={category}
                    categories={category}
                    labels={{
                      step: chartData.MarketCap.stepCount[index],
                      rotation: 90,
                      position: "start",
                    }}
                  />
                ))}
              </ChartCategoryAxis>
              <ChartValueAxis>
                <ChartValueAxisItem
                  name="primary"
                  color="#7D7D7D"
                  labels={{ format: "{0}%", position: "right" }}
                  majorGridLines={{ visible: false }}
                />
              </ChartValueAxis>
              <ChartSeries>
                {chartData.MarketCap.chartData.map((series) => (
                  <ChartSeriesItem
                    key={series.name}
                    type={series.type}
                    data={series.data}
                    name={series.name}
                    color={series.color}
                    tooltip={{ visible: true, format: "{0:n1}%" }}
                    opacity={1}
                    visibleInLegend={series.visibleInLegend}
                  />
                ))}
              </ChartSeries>
              <ChartLegend position="bottom" visible={true} />
            </Chart>
          </>
        ),
      };
      tiles.push(MarketCapTile);
    } else if (categoryId === ExposureCategory.Liquidity) {
      const LiquidityTile = {
        header: (
          <>
            <div className="d-flex justify-content-between">
              <b>
                {selectedAsset.AssetName} - Liquidity (
                {chartData.Liquidity.minDate} to {chartData.Liquidity.maxDate})
              </b>
            </div>
          </>
        ),
        body: (
          <>
            <Chart>
            <ChartCategoryAxis>
                {chartData.Liquidity.categories.map((category, index) => (
                  <ChartCategoryAxisItem
                    key={category}
                    categories={category}
                    labels={{
                      step: chartData.Liquidity.stepCount[index],
                      rotation: 90,
                      position: "start",
                    }}
                  />
                ))}
              </ChartCategoryAxis>
              <ChartValueAxis>
                <ChartValueAxisItem
                  name="primary"
                  color="#7D7D7D"
                  labels={{ format: "{0}%", position: "right" }}
                  majorGridLines={{ visible: false }}
                />
              </ChartValueAxis>
              <ChartSeries>
                {chartData.Liquidity.chartData.map((series) => (
                  <ChartSeriesItem
                    key={series.name}
                    type={series.type}
                    data={series.data}
                    name={series.name}
                    color={series.color}
                    tooltip={{ visible: true, format: "{0:n1}%" }}
                    opacity={1}
                    visibleInLegend={series.visibleInLegend}
                  />
                ))}
              </ChartSeries>
              <ChartLegend position="bottom" visible={true} />
            </Chart>
          </>
        ),
      };
      tiles.push(LiquidityTile);
    } else if (categoryId === ExposureCategory.Concentration) {
      const ConcentrationTile = {
        header: (
          <>
            <div className="d-flex justify-content-between">
              <b>
                {selectedAsset.AssetName} - Concentration (
                {chartData.Concentration.minDate} to{" "}
                {chartData.Concentration.maxDate})
              </b>
            </div>
          </>
        ),
        body: (
          <>
            <Chart>
            <ChartCategoryAxis>
                {chartData.Concentration.categories.map((category, index) => (
                  <ChartCategoryAxisItem
                    key={category}
                    categories={category}
                    labels={{
                      step: chartData.Concentration.stepCount[index],
                      rotation: 90,
                      position: "start",
                    }}
                  />
                ))}
              </ChartCategoryAxis>
              <ChartValueAxis>
                <ChartValueAxisItem
                  name="primary"
                  color="#7D7D7D"
                  labels={{ format: "{0}%", position: "right" }}
                  majorGridLines={{ visible: false }}
                />
              </ChartValueAxis>
              <ChartSeries>
                {chartData.Concentration.chartData.map((series) => (
                  <ChartSeriesItem
                    key={series.name}
                    type={series.type}
                    data={series.data}
                    name={series.name}
                    color={series.color}
                    tooltip={{ visible: true, format: "{0:n1}%" }}
                    opacity={1}
                    visibleInLegend={series.visibleInLegend}
                  />
                ))}
              </ChartSeries>
              <ChartLegend position="bottom" visible={true} />
            </Chart>
          </>
        ),
      };
      tiles.push(ConcentrationTile);
    } else if (categoryId === ExposureCategory.AssetLevel) {
      const AssetLevelTile = {
        header: (
          <>
            <div className="d-flex justify-content-between">
              <b>
                {selectedAsset.AssetName} - Asset Level (
                {chartData.AssetLevel.minDate} to {chartData.AssetLevel.maxDate}
                )
              </b>
            </div>
          </>
        ),
        body: (
          <>
            <Chart>
            <ChartCategoryAxis>
                {chartData.AssetLevel.categories.map((category, index) => (
                  <ChartCategoryAxisItem
                    key={category}
                    categories={category}
                    labels={{
                      step: chartData.AssetLevel.stepCount[index],
                      rotation: 90,
                      position: "start",
                    }}
                  />
                ))}
              </ChartCategoryAxis>
              <ChartValueAxis>
                <ChartValueAxisItem
                  name="primary"
                  color="#7D7D7D"
                  labels={{ format: "{0:n0}%", position: "right" }}
                  majorGridLines={{ visible: false }}
                />
              </ChartValueAxis>
              <ChartSeries>
                {chartData.AssetLevel.chartData.map((series) => (
                  <ChartSeriesItem
                    key={series.name}
                    type={series.type}
                    data={series.data}
                    name={series.name}
                    color={series.color}
                    tooltip={{ visible: true, format: "{0:n1}%" }}
                    opacity={1}
                    visibleInLegend={series.visibleInLegend}
                  />
                ))}
              </ChartSeries>
              <ChartLegend position="bottom" visible={true} />
            </Chart>
          </>
        ),
      };
      tiles.push(AssetLevelTile);
    } else if (categoryId === ExposureCategory.TotalNumberPositions) {
      const TotalNoofPositionsTile = {
        header: (
          <>
            <div className="d-flex justify-content-between">
              <b>
                {selectedAsset.AssetName} - Total Number of Positions (
                {chartData.TotalNumberPositions.minDate} to{" "}
                {chartData.TotalNumberPositions.maxDate})
              </b>
            </div>
          </>
        ),
        body: (
          <>
            <Chart>
            <ChartCategoryAxis>
                {chartData.TotalNumberPositions.categories.map((category, index) => (
                  <ChartCategoryAxisItem
                    key={category}
                    categories={category}
                    labels={{
                      step: chartData.TotalNumberPositions.stepCount[index],
                      rotation: 90,
                      position: "start",
                    }}
                  />
                ))}
              </ChartCategoryAxis>
              <ChartValueAxis>
                <ChartValueAxisItem
                  name="primary"
                  color="#7D7D7D"
                  labels={{ format: "{0}", position: "right" }}
                  majorGridLines={{ visible: false }}
                />
              </ChartValueAxis>
              <ChartSeries>
                {chartData.TotalNumberPositions.chartData.map((series) => (
                  <ChartSeriesItem
                    key={series.name}
                    type={series.type}
                    data={series.data}
                    name={series.name}
                    color={series.color}
                    tooltip={{ visible: true, format: "{0:n1}%" }}
                    opacity={1}
                    visibleInLegend={series.visibleInLegend}
                  />
                ))}
              </ChartSeries>
              <ChartLegend position="bottom" visible={true} />
            </Chart>
          </>
        ),
      };
      tiles.push(TotalNoofPositionsTile);
    } else if (categoryId === ExposureCategory.Leverage) {
      const LeverageTile = {
        header: (
          <>
            <div className="d-flex justify-content-between">
              <b>
                {selectedAsset.AssetName} - Leverage (
                {chartData.Leverage.minDate} to {chartData.Leverage.maxDate})
              </b>
            </div>
          </>
        ),
        body: (
          <>
            <Chart>
            <ChartCategoryAxis>
                {chartData.Leverage.categories.map((category, index) => (
                  <ChartCategoryAxisItem
                    key={category}
                    categories={category}
                    labels={{
                      step: chartData.Leverage.stepCount[index],
                      rotation: 90,
                      position: "start",
                    }}
                  />
                ))}
              </ChartCategoryAxis>
              <ChartValueAxis>
                <ChartValueAxisItem
                  name="primary"
                  color="#7D7D7D"
                  labels={{ format: "{0}", position: "right" }}
                  majorGridLines={{ visible: false }}
                />
              </ChartValueAxis>
              <ChartSeries>
                {chartData.Leverage.chartData.map((series) => (
                  <ChartSeriesItem
                    key={series.name}
                    type={series.type}
                    data={series.data}
                    name={series.name}
                    color={series.color}
                    tooltip={{ visible: true, format: "{0:n1}%" }}
                    opacity={1}
                    visibleInLegend={series.visibleInLegend}
                  />
                ))}
              </ChartSeries>
              <ChartLegend position="bottom" visible={true} />
            </Chart>
          </>
        ),
      };
      tiles.push(LeverageTile);
    } else if (categoryId === ExposureCategory.Sector_Gross) {
      const SectorGrossTile = {
        header: (
          <>
            <div className="d-flex justify-content-between">
              <b>
                {selectedAsset.AssetName} - Sector Gross Exposure (
                {chartData.Sector_Gross.minDate} to{" "}
                {chartData.Sector_Gross.maxDate})
              </b>
            </div>
          </>
        ),
        body: (
          <>
            <Chart>
            <ChartCategoryAxis>
                {chartData.Sector_Gross.categories.map((category, index) => (
                  <ChartCategoryAxisItem
                    key={category}
                    categories={category}
                    labels={{
                      step: chartData.Sector_Gross.stepCount[index],
                      rotation: 90,
                      position: "start",
                    }}
                  />
                ))}
              </ChartCategoryAxis>
              <ChartValueAxis>
                <ChartValueAxisItem
                  name="primary"
                  color="#7D7D7D"
                  labels={{ format: "{0}", position: "right" }}
                  majorGridLines={{ visible: false }}
                />
              </ChartValueAxis>
              <ChartSeries>
                {chartData.Sector_Gross.chartData.map((series) => (
                  <ChartSeriesItem
                    key={series.name}
                    type={series.type}
                    data={series.data}
                    name={series.name}
                    color={series.color}
                    tooltip={{ visible: true, format: "{0:n1}%" }}
                    opacity={1}
                    visibleInLegend={series.visibleInLegend}
                  />
                ))}
              </ChartSeries>
              <ChartLegend position="bottom" visible={true} />
            </Chart>
          </>
        ),
      };
      tiles.push(SectorGrossTile);
    } else if (categoryId === ExposureCategory.ProductAssetClass) {
      const ProductAssetClassTile = {
        header: (
          <>
            <div className="d-flex justify-content-between">
              <b>
                {selectedAsset.AssetName} - Sector Gross Exposure (
                {chartData.ProductAssetClass.minDate} to{" "}
                {chartData.ProductAssetClass.maxDate})
              </b>
            </div>
          </>
        ),
        body: (
          <>
            <Chart>
            <ChartCategoryAxis>
                {chartData.ProductAssetClass.categories.map((category, index) => (
                  <ChartCategoryAxisItem
                    key={category}
                    categories={category}
                    labels={{
                      step: chartData.ProductAssetClass.stepCount[index],
                      rotation: 90,
                      position: "start",
                    }}
                  />
                ))}
              </ChartCategoryAxis>
              <ChartValueAxis>
                <ChartValueAxisItem
                  name="primary"
                  color="#7D7D7D"
                  labels={{ format: "{0}", position: "right" }}
                  majorGridLines={{ visible: false }}
                />
              </ChartValueAxis>
              <ChartSeries>
                {chartData.ProductAssetClass.chartData.map((series) => (
                  <ChartSeriesItem
                    key={series.name}
                    type={series.type}
                    data={series.data}
                    name={series.name}
                    color={series.color}
                    tooltip={{ visible: true, format: "{0:n1}%" }}
                    opacity={1}
                    visibleInLegend={series.visibleInLegend}
                  />
                ))}
              </ChartSeries>
              <ChartLegend position="bottom" visible={true} />
            </Chart>
          </>
        ),
      };
      tiles.push(ProductAssetClassTile);
    } else if (categoryId === ExposureCategory.RatesCurrency) {
      const RatesorCurrencyTile = {
        header: (
          <>
            <div className="d-flex justify-content-between">
              <b>
                {selectedAsset.AssetName} - Rates or Currency (
                {chartData.RatesCurrency.minDate} to{" "}
                {chartData.RatesCurrency.maxDate})
              </b>
            </div>
          </>
        ),
        body: (
          <>
            <Chart>
            <ChartCategoryAxis>
                {chartData.RatesCurrency.categories.map((category, index) => (
                  <ChartCategoryAxisItem
                    key={category}
                    categories={category}
                    labels={{
                      step: chartData.RatesCurrency.stepCount[index],
                      rotation: 90,
                      position: "start",
                    }}
                  />
                ))}
              </ChartCategoryAxis>
              <ChartValueAxis>
                <ChartValueAxisItem
                  name="primary"
                  color="#7D7D7D"
                  labels={{ format: "{0}", position: "right" }}
                  majorGridLines={{ visible: false }}
                />
              </ChartValueAxis>
              <ChartSeries>
                {chartData.RatesCurrency.chartData.map((series) => (
                  <ChartSeriesItem
                    key={series.name}
                    type={series.type}
                    data={series.data}
                    name={series.name}
                    color={series.color}
                    tooltip={{ visible: true, format: "{0:n1}%" }}
                    opacity={1}
                    visibleInLegend={series.visibleInLegend}
                  />
                ))}
              </ChartSeries>
              <ChartLegend position="bottom" visible={true} />
            </Chart>
          </>
        ),
      };
      tiles.push(RatesorCurrencyTile);
    } else if (categoryId === ExposureCategory.OptionPremium) {
      const OptionPremiumTile = {
        header: (
          <>
            <div className="d-flex justify-content-between">
              <b>
                {selectedAsset.AssetName} - Option Premium (
                {chartData.OptionPremium.minDate} to{" "}
                {chartData.OptionPremium.maxDate})
              </b>
            </div>
          </>
        ),
        body: (
          <>
            <Chart>
            <ChartCategoryAxis>
                {chartData.OptionPremium.categories.map((category, index) => (
                  <ChartCategoryAxisItem
                    key={category}
                    categories={category}
                    labels={{
                      step: chartData.OptionPremium.stepCount[index],
                      rotation: 90,
                      position: "start",
                    }}
                  />
                ))}
              </ChartCategoryAxis>
              <ChartValueAxis>
                <ChartValueAxisItem
                  name="primary"
                  color="#7D7D7D"
                  labels={{ format: "{0}", position: "right" }}
                  majorGridLines={{ visible: false }}
                />
              </ChartValueAxis>
              <ChartSeries>
                {chartData.OptionPremium.chartData.map((series) => (
                  <ChartSeriesItem
                    key={series.name}
                    type={series.type}
                    data={series.data}
                    name={series.name}
                    color={series.color}
                    tooltip={{ visible: true, format: "{0:n1}%" }}
                    opacity={1}
                    visibleInLegend={series.visibleInLegend}
                  />
                ))}
              </ChartSeries>
              <ChartLegend position="bottom" visible={true} />
            </Chart>
          </>
        ),
      };
      tiles.push(OptionPremiumTile);
    } else if (categoryId === ExposureCategory.OptionDAE) {
      const OptionDaeTile = {
        header: (
          <>
            <div className="d-flex justify-content-between">
              <b>
                {selectedAsset.AssetName} - Option DAE (
                {chartData.OptionDAE.minDate} to {chartData.OptionDAE.maxDate})
              </b>
            </div>
          </>
        ),
        body: (
          <>
            <Chart>
            <ChartCategoryAxis>
                {chartData.OptionDAE.categories.map((category, index) => (
                  <ChartCategoryAxisItem
                    key={category}
                    categories={category}
                    labels={{
                      step: chartData.OptionDAE.stepCount[index],
                      rotation: 90,
                      position: "start",
                    }}
                  />
                ))}
              </ChartCategoryAxis>
              <ChartValueAxis>
                <ChartValueAxisItem
                  name="primary"
                  color="#7D7D7D"
                  labels={{ format: "{0}", position: "right" }}
                  majorGridLines={{ visible: false }}
                />
              </ChartValueAxis>
              <ChartSeries>
                {chartData.OptionDAE.chartData.map((series) => (
                  <ChartSeriesItem
                    key={series.name}
                    type={series.type}
                    data={series.data}
                    name={series.name}
                    color={series.color}
                    tooltip={{ visible: true, format: "{0:n1}%" }}
                    opacity={1}
                    visibleInLegend={series.visibleInLegend}
                  />
                ))}
              </ChartSeries>
              <ChartLegend position="bottom" visible={true} />
            </Chart>
          </>
        ),
      };
      tiles.push(OptionDaeTile);
    } else if (categoryId === ExposureCategory.AUM) {
      const AssetAumTile = {
        header: (
          <>
            <div className="d-flex justify-content-between">
              <b>
                {selectedAsset.AssetName} - AUM ($MM) ({chartData.AUM.minDate}{" "}
                to {chartData.AUM.maxDate})
              </b>
            </div>
          </>
        ),
        body: (
          <>
            <Chart>
            <ChartCategoryAxis>
                {chartData.AUM.categories.map((category, index) => (
                  <ChartCategoryAxisItem
                    key={category}
                    categories={category}
                    labels={{
                      step: chartData.AUM.stepCount[index],
                      rotation: 90,
                      position: "start",
                    }}
                  />
                ))}
              </ChartCategoryAxis>
              <ChartValueAxis>
                <ChartValueAxisItem
                  name="primary"
                  color="#7D7D7D"
                  labels={{ format: "{0}", position: "right" }}
                  majorGridLines={{ visible: false }}
                />
              </ChartValueAxis>
              <ChartSeries>
                {chartData.AUM.chartData.map((series) => (
                  <ChartSeriesItem
                    key={series.name}
                    type={series.type}
                    data={series.data}
                    name={series.name}
                    color={series.color}
                    tooltip={{ visible: true, format: "{0:n1}%" }}
                    opacity={1}
                    visibleInLegend={series.visibleInLegend}
                  />
                ))}
              </ChartSeries>
              <ChartLegend position="bottom" visible={true} />
            </Chart>
          </>
        ),
      };
      tiles.push(AssetAumTile);
    } else if (categoryId === ExposureCategory.Valuations) {
      const ValuationsTile = {
        header: (
          <>
            <div className="d-flex justify-content-between">
              <b>
                {selectedAsset.AssetName} - Valuations (
                {chartData.Valuations.minDate} to {chartData.Valuations.maxDate}
                )
              </b>
            </div>
          </>
        ),
        body: (
          <>
            <Chart>
            <ChartCategoryAxis>
                {chartData.Valuations.categories.map((category, index) => (
                  <ChartCategoryAxisItem
                    key={category}
                    categories={category}
                    labels={{
                      step: chartData.Valuations.stepCount[index],
                      rotation: 90,
                      position: "start",
                    }}
                  />
                ))}
              </ChartCategoryAxis>
              <ChartValueAxis>
                <ChartValueAxisItem
                  name="primary"
                  color="#7D7D7D"
                  labels={{ format: "{0}", position: "right" }}
                  majorGridLines={{ visible: false }}
                />
              </ChartValueAxis>
              <ChartSeries>
                {chartData.Valuations.chartData.map((series) => (
                  <ChartSeriesItem
                    key={series.name}
                    type={series.type}
                    data={series.data}
                    name={series.name}
                    color={series.color}
                    tooltip={{ visible: true, format: "{0:n1}%" }}
                    opacity={1}
                    visibleInLegend={series.visibleInLegend}
                  />
                ))}
              </ChartSeries>
              <ChartLegend position="bottom" visible={true} />
            </Chart>
          </>
        ),
      };
      tiles.push(ValuationsTile);
    } else if (categoryId === ExposureCategory.Privates) {
      const PrivatesTile = {
        header: (
          <>
            <div className="d-flex justify-content-between">
              <b>
                {selectedAsset.AssetName} - Privates (
                {chartData.Privates.minDate} to {chartData.Privates.maxDate})
              </b>
            </div>
          </>
        ),
        body: (
          <>
            <Chart>
            <ChartCategoryAxis>
                {chartData.Privates.categories.map((category, index) => (
                  <ChartCategoryAxisItem
                    key={category}
                    categories={category}
                    labels={{
                      step: chartData.Privates.stepCount[index],
                      rotation: 90,
                      position: "start",
                    }}
                  />
                ))}
              </ChartCategoryAxis>
              <ChartValueAxis>
                <ChartValueAxisItem
                  name="primary"
                  color="#7D7D7D"
                  labels={{ format: "{0}", position: "right" }}
                  majorGridLines={{ visible: false }}
                />
              </ChartValueAxis>
              <ChartSeries>
                {chartData.Privates.chartData.map((series) => (
                  <ChartSeriesItem
                    key={series.name}
                    type={series.type}
                    data={series.data}
                    name={series.name}
                    color={series.color}
                    tooltip={{ visible: true, format: "{0:n1}%" }}
                    opacity={1}
                    visibleInLegend={series.visibleInLegend}
                  />
                ))}
              </ChartSeries>
              <ChartLegend position="bottom" visible={true} />
            </Chart>
          </>
        ),
      };
      tiles.push(PrivatesTile);
    } else if (categoryId === ExposureCategory.Credit) {
      const AssetCreditChartTile = {
        header: (
          <>
            <div className="d-flex justify-content-between">
              <b>
                {selectedAsset.AssetName} - Credit ({chartData.Credit.minDate}{" "}
                to {chartData.Credit.maxDate})
              </b>
            </div>
          </>
        ),
        body: (
          <>
            <Chart>
            <ChartCategoryAxis>
                {chartData.Credit.categories.map((category, index) => (
                  <ChartCategoryAxisItem
                    key={category}
                    categories={category}
                    labels={{
                      step: chartData.Credit.stepCount[index],
                      rotation: 90,
                      position: "start",
                    }}
                  />
                ))}
              </ChartCategoryAxis>
              <ChartValueAxis>
                <ChartValueAxisItem
                  name="primary"
                  color="#7D7D7D"
                  labels={{ format: "{0}%", position: "right" }}
                  majorGridLines={{ visible: false }}
                />
              </ChartValueAxis>
              <ChartSeries>
                {chartData.Credit.chartData.map((series) => (
                  <ChartSeriesItem
                    key={series.name}
                    type={series.type}
                    data={series.data}
                    name={series.name}
                    color={series.color}
                    tooltip={{ visible: true, format: "{0:n1}%" }}
                    opacity={1}
                    visibleInLegend={series.visibleInLegend}
                  />
                ))}
              </ChartSeries>
              <ChartLegend position="bottom" visible={true} />
            </Chart>
          </>
        ),
      };
      tiles.push(AssetCreditChartTile);
    } else if (categoryId === ExposureCategory.Geography_Gross) {
      const GeographyGrossExposureChartTile = {
        header: (
          <>
            <div className="d-flex justify-content-between">
              <b>
                {selectedAsset.AssetName} - Geography Gross Exposure (
                {chartData.Geography_Gross.minDate} to{" "}
                {chartData.Geography_Gross.maxDate})
              </b>
            </div>
          </>
        ),
        body: (
          <>
            <Chart>
              <ChartTitle />
              <ChartCategoryAxis>
                {chartData.Geography_Gross.categories.map((category, index) => (
                  <ChartCategoryAxisItem
                    key={category}
                    categories={category}
                    labels={{
                      step: chartData.Geography_Gross.stepCount[index],
                      rotation: 90,
                      position: "start",
                    }}
                  />
                ))}
              </ChartCategoryAxis>
              <ChartValueAxis>
                <ChartValueAxisItem
                  name="primary"
                  color="#7D7D7D"
                  labels={{ format: "{0}%", position: "right" }}
                  majorGridLines={{ visible: false }}
                />
              </ChartValueAxis>
              <ChartSeries>
                {chartData.Geography_Gross.chartData.map((series) => (
                  <ChartSeriesItem
                    key={series.name}
                    type={series.type}
                    data={series.data}
                    name={series.name}
                    color={series.color}
                    tooltip={{ visible: true, format: "{0:n1}%" }}
                    opacity={1}
                    visibleInLegend={series.visibleInLegend}
                  />
                ))}
              </ChartSeries>
              <ChartLegend position="bottom" visible={true} />
            </Chart>
          </>
        ),
      };
      tiles.push(GeographyGrossExposureChartTile);
    } else if (categoryId === ExposureCategory.Market_Cap_Gross) {
      const MarketCapGrossExposureChartTile = {
        header: (
          <>
            <div className="d-flex justify-content-between">
              <b>
                {selectedAsset.AssetName} - Market Cap Gross Exposure (
                {chartData.Market_Cap_Gross.minDate} to{" "}
                {chartData.Market_Cap_Gross.maxDate})
              </b>
            </div>
          </>
        ),
        body: (
          <>
            <Chart>
              <ChartTitle />
              <ChartCategoryAxis>
                {chartData.Market_Cap_Gross.categories.map((category, index) => (
                  <ChartCategoryAxisItem
                    key={category}
                    categories={category}
                    labels={{
                      step: chartData.Market_Cap_Gross.stepCount[index],
                      rotation: 90,
                      position: "start",
                    }}
                  />
                ))}
              </ChartCategoryAxis>
              <ChartValueAxis>
                <ChartValueAxisItem
                  name="primary"
                  color="#7D7D7D"
                  labels={{ format: "{0}%", position: "right" }}
                  majorGridLines={{ visible: false }}
                />
              </ChartValueAxis>
              <ChartSeries>
                {chartData.Market_Cap_Gross.chartData.map((series) => (
                  <ChartSeriesItem
                    key={series.name}
                    type={series.type}
                    data={series.data}
                    name={series.name}
                    color={series.color}
                    tooltip={{ visible: true, format: "{0:n1}%" }}
                    opacity={1}
                    visibleInLegend={series.visibleInLegend}
                  />
                ))}
              </ChartSeries>
              <ChartLegend position="bottom" visible={true} />
            </Chart>
          </>
        ),
      };
      tiles.push(MarketCapGrossExposureChartTile);
    } else if (categoryId === ExposureCategory.Asset_Level_Of_Gross) {
      const AssetLevelofGrossExposureChartTile = {
        header: (
          <>
            <div className="d-flex justify-content-between">
              <b>
                {selectedAsset.AssetName} - Asset Level of Gross Exposure (
                {chartData.Asset_Level_Of_Gross.minDate} to{" "}
                {chartData.Asset_Level_Of_Gross.maxDate})
              </b>
            </div>
          </>
        ),
        body: (
          <>
            <Chart>
              <ChartTitle />
              <ChartCategoryAxis>
                {chartData.Asset_Level_Of_Gross.categories.map((category, index) => (
                  <ChartCategoryAxisItem
                    key={category}
                    categories={category}
                    labels={{
                      step: chartData.Asset_Level_Of_Gross.stepCount[index],
                      rotation: 90,
                      position: "start",
                    }}
                  />
                ))}
              </ChartCategoryAxis>
              <ChartValueAxis>
                <ChartValueAxisItem
                  name="primary"
                  color="#7D7D7D"
                  labels={{ format: "{0}%", position: "right" }}
                  majorGridLines={{ visible: false }}
                />
              </ChartValueAxis>
              <ChartSeries>
                {chartData.Asset_Level_Of_Gross.chartData.map((series) => (
                  <ChartSeriesItem
                    key={series.name}
                    type={series.type}
                    data={series.data}
                    name={series.name}
                    color={series.color}
                    tooltip={{ visible: true, format: "{0:n1}%" }}
                    opacity={1}
                    visibleInLegend={series.visibleInLegend}
                  />
                ))}
              </ChartSeries>
              <ChartLegend position="bottom" visible={true} />
            </Chart>
          </>
        ),
      };
      tiles.push(AssetLevelofGrossExposureChartTile);
    } else if (categoryId === ExposureCategory.Asset_Concentration_Gross) {
      const AssetConcentrationGrossChartTile = {
        header: (
          <>
            <div className="d-flex justify-content-between">
              <b>
                {selectedAsset.AssetName} - Asset Level of Gross Exposure (
                {chartData.Asset_Concentration_Gross.minDate} to{" "}
                {chartData.Asset_Concentration_Gross.maxDate})
              </b>
            </div>
          </>
        ),
        body: (
          <>
            <Chart>
              <ChartTitle />
              <ChartCategoryAxis>
                {chartData.Asset_Concentration_Gross.categories.map((category, index) => (
                  <ChartCategoryAxisItem
                    key={category}
                    categories={category}
                    labels={{
                      step: chartData.Asset_Concentration_Gross.stepCount[index],
                      rotation: 90,
                      position: "start",
                    }}
                  />
                ))}
              </ChartCategoryAxis>
              <ChartValueAxis>
                <ChartValueAxisItem
                  name="primary"
                  color="#7D7D7D"
                  labels={{ format: "{0}%", position: "right" }}
                  majorGridLines={{ visible: false }}
                />
              </ChartValueAxis>
              <ChartSeries>
                {chartData.Asset_Concentration_Gross.chartData.map((series) => (
                  <ChartSeriesItem
                    key={series.name}
                    type={series.type}
                    data={series.data}
                    name={series.name}
                    color={series.color}
                    tooltip={{ visible: true, format: "{0:n1}%" }}
                    opacity={1}
                    visibleInLegend={series.visibleInLegend}
                  />
                ))}
              </ChartSeries>
              <ChartLegend position="bottom" visible={true} />
            </Chart>
          </>
        ),
      };
      tiles.push(AssetConcentrationGrossChartTile);
    }
  });

  const handleReposition = (e) => {
    setData(e.value);
  };

  return (
    <>
      <form action="#">
        <div className="row flex-wrap">
          <div className="col-md-4">
            <label
              htmlFor="select-fund"
              className="mb-1 ms-2 fw-semibold fs-12"
            >
              Select Asset
            </label>
            <div>
              <SBAComboBox
                filterable={true}
                data={assetListData}
                textField="AssetName"
                valueField="AssetId"
                value={currentAsset}
                onChange={AssestDDChanged}
              />
            </div>
          </div>

          <div className="col-md-4">
            <label htmlFor="from-date" className="mb-1 ms-2 fw-semibold fs-12">
              Date Range
            </label>
            <div className="">
              <SBDateRangePicker 
              value={{
               start: startDate ? moment(startDate).toDate() : new Date(),
                end :endDate ? moment(endDate).toDate() : new Date()
              }}
              onChange={handleDateChange}
              />
              {/* <DateRangePicker
                className="SbaDateRage text-dark"
                value={[
                  startDate ? moment(startDate).toDate() : new Date(),
                  endDate ? moment(endDate).toDate() : new Date(),
                ]}
                format="MM/dd/yyyy"
                onChange={handleDateChange}
                block
                character=" - "
              /> */}
            </div>
          </div>

          <div className="col-md-4">
            <label htmlFor="to-date" className="mb-1 ms-2 fw-semibold fs-12">
              Available Exposure Charts:
            </label>
            {exposureCategoryTypeData?.length > 0 ?  (
              <div>
                {exposureCategoryTypeData.map((item, index) => {
                  const { ExposureCategoryType, ExposureCategoryTypeId } = item;
                  const isChecked = checkedCategories.some(
                    (checkedItem) =>
                      checkedItem.categoryType === ExposureCategoryType
                  );

                  return (
                    <div key={index} style={{ display: "block" }}>
                      <label>
                        <input
                          className="me-2"
                          type="checkbox"
                          checked={isChecked}
                          onChange={(event) =>
                            handleCategoryTypeChange(
                              event,
                              ExposureCategoryType,
                              ExposureCategoryTypeId
                            )
                          }
                        />
                        {ExposureCategoryType}
                      </label>
                    </div>
                  );
                })}
              </div> ) : (
              <div class="card-body">No Data Available</div>
            )
            }
          </div>
        </div>

        <div className="mt-3">
          <button
            type="button"
            className="cancel-btn"
            onClick={clearButtonClick}
          >
            Clear All
          </button>
          <button
            type="button"
            className="enter-btn ms-2"
            onClick={() => {setLoading(true); enterButtonClick()}}
          >
            Enter
          </button>
        </div>
      </form>

      <br></br>
      {!Loading ? ( widgetView && (
       <> 
       <div id="content" className="dashboard">
         <TileLayout
           columns={4}
           rowHeight={255}
           positions={data}
           gap={{
             rows: 10,
             columns: 10,
           }}
           items={tiles}
           onReposition={handleReposition}
         />
     </div> </>)
      ) : (
        <LoadingScreen />
      )}
    </>
  );
};
